import { z } from "zod/v4";

export const seasonStatusSchema = z.enum(["draft", "active", "archived"]);

export const trainingSeasonSchema = z.object({
	chat_room_id: z.string().uuid().nullable().optional(),
	club_id: z.string().uuid(),
	created_at: z.coerce.date(),
	end_date: z.coerce.date(),
	group_count: z.number().int(),
	id: z.string().uuid(),
	name: z.string(),
	registration_open: z.boolean(),
	setup_completed_at: z.coerce.date().nullable().optional(),
	start_date: z.coerce.date(),
	status: seasonStatusSchema,
});

export const createTrainingSeasonSchema = z.object({
	end_date: z.string().min(1, "End date is required"),
	name: z.string().min(1, "Name is required"),
	start_date: z.string().min(1, "Start date is required"),
});

export const updateTrainingSeasonSchema = z.object({
	end_date: z.string().optional(),
	name: z.string().min(1).optional(),
	registration_open: z.boolean().optional(),
	start_date: z.string().optional(),
	status: seasonStatusSchema.optional(),
});

export const paginatedSeasonsSchema = z.object({
	items: z.array(trainingSeasonSchema),
	limit: z.number(),
	offset: z.number(),
	total: z.number(),
});

export const duplicateSeasonSchema = z.object({
	copy_exclusion_dates: z.boolean(),
	end_date: z.string().min(1, "End date is required"),
	name: z.string().min(1, "Name is required"),
	start_date: z.string().min(1, "Start date is required"),
});
